// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"resources_js_components_Header_vue":1,"resources_js_components_SliderGallery_vue":1,"resources_js_components_Map_vue":1,"resources_js_components_Gallery_vue":1,"resources_js_components_Tabs_vue":1,"resources_js_components_Collapsible_vue":1,"resources_js_components_ProductGallery_vue":1}[chunkId]) return "js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};